const USER_ROLES = {
  SUPER_ADMIN: 'superAdmin',
  ADMIN: 'admin',
  BILLING_MANAGER: 'billingManager',
  TEAM_MEMBER: 'teamMember',
  GUEST: 'guest',
};

export default USER_ROLES;
